import { useEffect } from 'react';
import { useScrollLock } from '@shared/hooks';
import { cn } from '@shared/utils';
import CloseIcon from '@assets/images/close-black.svg';

interface ModalProps {
  className?: string;
  titleClassName?: string;
  closeClassName?: string;
  title?: string;
  width?: string | number;
  setAutoCloseSeconds?: number;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Modal = (props: ModalProps) => {
  const { lock, unlock } = useScrollLock({ autoLock: false });

  useEffect(() => {
    props.isOpen ? lock() : unlock();
  }, [props.isOpen]);

  useEffect(() => {
    if (!props.isOpen || !props.setAutoCloseSeconds) return;
    const timerId = setTimeout(() => props.onClose(), props.setAutoCloseSeconds * 1000);
    return () => clearTimeout(timerId);
  }, [props.isOpen, props.setAutoCloseSeconds, props.onClose]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.currentTarget === e.target) props.onClose();
  };

  if (!props.isOpen) return;
  return (
    <div className='fixed top-0 left-0 z-999 flex h-dvh w-dvw bg-[#1d1d21b3]' onClick={handleOverlayClick}>
      <div
        className={cn(
          'absolute top-1/2 right-auto bottom-auto left-1/2 z-999 h-fit w-full max-w-129.5 -translate-1/2 overflow-y-auto rounded-lg bg-white',
          'max-md:h-[calc(100%-32px)] max-md:max-h-fit max-md:w-[calc(100%-32px)]',
        )}
      >
        <div className={cn('mx-auto', props.className)}>
          <CloseIcon className='absolute top-6 right-6 cursor-pointer' onClick={props.onClose} />
          {props.title && (
            <h2
              className={cn(
                'flex flex-col px-4 py-9 text-center font-[Prata] text-[28px] font-medium text-[#0f0f11]',
                'max-md:h-15 max-md:justify-center max-md:border-b max-md:border-b-[#4c4c4c15] max-md:py-0 max-md:text-left max-md:text-lg',
                props.titleClassName,
              )}
            >
              {props.title}
            </h2>
          )}
          <div className={cn('max-auto px-12 pb-6 text-center', 'max-md:p-6', !props.title && 'pt-9')}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};
